var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a-layout-sider', {
    class: (_class = {}, _class[_vm.$style.menu] = true, _class[_vm.$style.white] = _vm.settings.menuColor === 'white', _class[_vm.$style.gray] = _vm.settings.menuColor === 'gray', _class[_vm.$style.dark] = _vm.settings.menuColor === 'dark', _class[_vm.$style.unfixed] = _vm.settings.isMenuUnfixed, _class[_vm.$style.shadow] = _vm.settings.isMenuShadow, _class),
    attrs: {
      "width": _vm.settings.leftMenuWidth,
      "collapsible": _vm.settings.isMobileView ? false : true,
      "collapsed": _vm.settings.isMenuCollapsed && !_vm.settings.isMobileView
    },
    on: {
      "collapse": _vm.onCollapse
    }
  }, [_c('div', {
    class: _vm.$style.menuOuter,
    style: {
      width: _vm.settings.isMenuCollapsed && !_vm.settings.isMobileView ? '80px' : _vm.settings.leftMenuWidth + 'px',
      height: _vm.settings.isMobileView || _vm.settings.isMenuUnfixed ? 'calc(100% - 64px)' : 'calc(100% - 110px)'
    }
  }, [_c('div', {
    class: _vm.$style.logoContainer
  }, [_c('div', {
    class: _vm.$style.logo
  }, [!_vm.settings.isMenuCollapsed ? _c('img', {
    staticClass: "logo pl-4",
    attrs: {
      "src": "/resources/images/logo.png"
    }
  }) : _c('img', {
    staticClass: "logo mr-2",
    attrs: {
      "width": "100%",
      "src": "/resources/images/logo.png"
    }
  })])]), _c('vue-custom-scrollbar', {
    style: {
      height: _vm.settings.isMobileView || _vm.settings.isMenuUnfixed ? 'calc(100vh - 64px)' : 'calc(100vh - 110px)'
    }
  }, [_c('a-menu', {
    class: _vm.$style.navigation,
    attrs: {
      "forceSubMenuRender": "",
      "inlineCollapsed": _vm.settings.isMobileView ? false : _vm.settings.isMenuCollapsed,
      "mode": 'inline',
      "selectedKeys": _vm.selectedKeys,
      "openKeys": _vm.openKeys,
      "inlineIndent": 15
    },
    on: {
      "update:openKeys": function updateOpenKeys($event) {
        _vm.openKeys = $event;
      },
      "update:open-keys": function updateOpenKeys($event) {
        _vm.openKeys = $event;
      },
      "click": _vm.handleClick,
      "openChange": _vm.handleOpenChange
    }
  }, [_vm._l(_vm.menuData, function (item, index) {
    return [!item.roles || item.roles.includes(_vm.user.role) ? [item.category ? _c('a-menu-item-group', {
      key: index
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(item.title))])], 2) : _vm._e(), !item.children && !item.category ? _c('item', {
      key: item.key,
      attrs: {
        "menu-info": item,
        "styles": _vm.$style
      }
    }) : _vm._e(), item.children ? _c('sub-menu', {
      key: item.key,
      attrs: {
        "menu-info": item,
        "styles": _vm.$style
      }
    }) : _vm._e()] : _vm._e()];
  })], 2), _vm.user.role == 'administrator' || _vm.user.role == 'operator' ? _c('div', {
    class: _vm.$style.banner,
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn btn-sm btn-success btn-rounded px-3",
    attrs: {
      "href": "/auctions/create",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Schedule auction")])]) : _vm._e()], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }